const $inject = [];

const lbaUrl = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '<',
    },
    bindToController: true,
    controller: 'lbaUrlCtrl',
    controllerAs: 'vm',
    template: require('./lbaUrl.html')
  }
};

lbaUrl.$inject = $inject;

export default lbaUrl;



// WEBPACK FOOTER //
// ./src/components/lbaUrl/lbaUrlDir.js